import { Outlet } from 'react-router-dom'

import { Auth, User } from 'Components/Layout'
import { Lazy } from 'Components/Loader'

import Password from 'Components/FormGroup/Password'

const user = [
    {
        path: 'user',
        element: <Auth guard="user" />,
        children: [
            { path: 'verify-email', element: <Lazy view="Auth/VerifyEmail" /> },
            { path: 'verify-email/:id/:hash', element: <Lazy view="Auth/VerifyEmail" /> },
        ],
    },
    {
        path: 'user',
        element: <User guard="user" />,
        children: [
            { path: '', element: <Lazy view="User/Dashboard" /> },
            { path: 'profile', element: <Lazy view="User/Dashboard/Profile" /> },
            { path: 'password', element: <Password /> },
            {
                path: 'roles',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Roles/List" /> },
                    { path: 'create', element: <Lazy view="User/Roles/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Roles/Create" title="Edit" /> },
                ],
            },
            {
                path: 'users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Users/List" /> },
                    { path: 'create', element: <Lazy view="User/Users/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Users/Create" title="Edit" /> },
                ],
            },
            {
                path: 'stores',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Stores/List" /> },
                    { path: 'create', element: <Lazy view="User/Stores/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Stores/Create" title="Edit" /> },
                ],
            },
            {
                path: 'store-users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/StoreUsers/List" /> },
                    { path: 'create', element: <Lazy view="User/StoreUsers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/StoreUsers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'bank-accounts',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/BankAccounts/List" /> },
                    { path: 'create', element: <Lazy view="User/BankAccounts/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/BankAccounts/Create" title="Edit" /> },
                ],
            },
            {
                path: 'wallet-transactions',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/WalletTransactions/List" /> },
                    { path: 'create', element: <Lazy view="User/WalletTransactions/Create" title="Add new" /> },
                ],
            },
            {
                path: 'bank-transactions',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/BankTransactions/List" /> },
                    { path: 'create', element: <Lazy view="User/BankTransactions/Create" title="Add new" /> },
                ],
            },
            {
                path: 'brands',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Brands/List" /> },
                    { path: 'create', element: <Lazy view="User/Brands/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Brands/Create" title="Edit" /> },
                ],
            },
            {
                path: 'categories',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Categories/List" /> },
                    { path: 'create', element: <Lazy view="User/Categories/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Categories/Create" title="Edit" /> },
                ],
            },
            {
                path: 'attributes',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Attributes/List" /> },
                    { path: 'create', element: <Lazy view="User/Attributes/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Attributes/Create" title="Edit" /> },
                ],
            },
            {
                path: 'expenses',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Expenses/List" /> },
                    { path: 'create', element: <Lazy view="User/Expenses/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Expenses/Create" title="Edit" /> },
                ],
            },
            {
                path: 'customers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Customers/List" /> },
                    { path: 'create', element: <Lazy view="User/Customers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Customers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'vendors',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Vendors/List" /> },
                    { path: 'create', element: <Lazy view="User/Vendors/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Vendors/Create" title="Edit" /> },
                ],
            },
            {
                path: 'referrals',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Referrals/List" /> },
                    { path: 'create', element: <Lazy view="User/Referrals/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Referrals/Create" title="Edit" /> },
                ],
            },
            {
                path: 'products',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Products/List" /> },
                    { path: 'create', element: <Lazy view="User/Products/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Products/Create" title="Edit" /> },
                ],
            },
            {
                path: 'purchases',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Purchases/List" /> },
                    { path: 'create', element: <Lazy view="User/Purchases/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Purchases/Create" title="Edit" /> },
                ],
            },
            {
                path: 'store-orders',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/StoreOrders/List" /> },
                    { path: 'create', element: <Lazy view="User/StoreOrders/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/StoreOrders/Create" title="Edit" /> },
                ],
            },
            {
                path: 'orders',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Orders/List" /> },
                    { path: 'create', element: <Lazy view="User/Orders/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Orders/Create" title="Edit" /> },
                ],
            },
            {
                path: 'analysis',
                element: <Outlet />,
                children: [
                    { path: 'purchases', element: <Lazy view="User/Analysis/Purchases" /> },
                    { path: 'store-orders', element: <Lazy view="User/Analysis/StoreOrders" /> },
                    { path: 'orders', element: <Lazy view="User/Analysis/Orders" /> },
                ],
            },
        ],
    },
]

export default user
